import axiosInstance from "@/api/axiosInstance";
import { CoachAttemptDetail } from "@/modules/growthStages/features/Diagnostics/types/diagnostic";

export const fetchAttemptForReview = async (
  attemptId: number,
): Promise<CoachAttemptDetail> => {
  const response = await axiosInstance.get<CoachAttemptDetail>(
    `/api/private/attempts/${attemptId}/review`,
  );
  return response.data;
};
